(function($) {
    'use strict';

    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    $('.all').addClass('active');
    $('#filter-offers').on('click', 'button', function(e) {

        $('.cat').removeClass('active');
        $(e.currentTarget).addClass('active');

        e.preventDefault();

        $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'get_tax_by_filter_ajax',
                filter_val: $(this).attr('data-filter'),
            },
            beforeSend: function(data) {

            },
            success: function(data) {
                $('.offers_slider .splide__list').html(data);
                var slideWidth = isMobile ? 300 : 400;
                var slideGap = isMobile ? 16 : 40;
                var offersSlider = new Splide('.offers_slider', {
                    fixedWidth: slideWidth,
                    gap: slideGap,
                    arrows: false,
                    pagination: false,
                    autoHeight: true,
                });
                offersSlider.mount();
                var _Components = offersSlider.Components,
                    Controller = _Components.Controller,
                    Move = _Components.Move;
                var prevButton = document.querySelector(
                    '.offers_slider_wrapper .prev_button');
                prevButton.style.display = 'none';
                prevButton.addEventListener('click', function() {
                    var maxPosition = Math.min(Move.getPosition() +
                        slideWidth +
                        slideGap, 0);
                    Controller.scroll(maxPosition);
                });
                var nextButton = document.querySelector(
                    '.offers_slider_wrapper .next_button');
                nextButton.addEventListener('click', function() {
                    var minPosition = Math.max(Move.getPosition() -
                        slideWidth -
                        slideGap, Move.getLimit(true));
                    Controller.scroll(minPosition);
                });
                offersSlider.on('moved', hideArrows);
                offersSlider.on('scrolled', hideArrows);

                function hideArrows() {
                    var position = Move.getPosition();
                    var limit = Move.getLimit(true);
                    if (position >= 0) {
                        prevButton.style.display = 'none';
                    } else {
                        prevButton.style.display = 'inline-flex';
                    }
                    if (position <= limit) {
                        nextButton.style.display = 'none';
                    } else {
                        nextButton.style.display = 'inline-flex';
                    }
                }
            },
        });
    });

    $('#filter-additional-services').on('click', 'button', function(e) {

        $('.cat').removeClass('active');
        $(e.currentTarget).addClass('active');

        e.preventDefault();

        $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'get_tax_by_additional_services_ajax',
                filter_val: $(this).attr('data-filter'),
            },
            beforeSend: function(data) {

            },
            success: function(data) {

                console.log('success');

                $('.additional_services_slider .splide__list').html(data);

                var slideWidth = isMobile ? 300 : 400;
                var slideGap = isMobile ? 16 : 40;
                var additionalSlider = new Splide(
                    '.additional_services_slider',
                    {
                        fixedWidth: slideWidth,
                        gap: slideGap,
                        arrows: false,
                        pagination: false,
                        autoHeight: true,
                    },
                );
                additionalSlider.mount();
                var _Components = additionalSlider.Components,
                    additionalController = _Components.Controller,
                    Move = _Components.Move;
                var additionalprevButton = document.querySelector(
                    '.additional_services_slider_wrapper .prev_button');
                additionalprevButton.style.display = 'none';
                additionalprevButton.addEventListener('click', function() {
                    var maxPosition = Math.min(Move.getPosition() +
                        slideWidth +
                        slideGap, 0);
                    additionalController.scroll(maxPosition);
                });
                var additionalnextButton = document.querySelector(
                    '.additional_services_slider_wrapper .next_button');
                additionalnextButton.addEventListener('click', function() {
                    var minPosition = Math.max(Move.getPosition() -
                        slideWidth -
                        slideGap, Move.getLimit(true));
                    additionalController.scroll(minPosition);
                });
                additionalSlider.on('moved', hideArrows);
                additionalSlider.on('scrolled', hideArrows);

                function hideArrows() {
                    var position = Move.getPosition();
                    var limit = Move.getLimit(true);
                    if (position >= 0) {
                        additionalprevButton.style.display = 'none';
                    } else {
                        additionalprevButton.style.display = 'inline-flex';
                    }
                    if (position <= limit) {
                        additionalnextButton.style.display = 'none';
                    } else {
                        additionalnextButton.style.display = 'inline-flex';
                    }
                }

            },
        });
    });

    $('#filter-news').on('click', 'button', function(e) {

        $('.cat').removeClass('active');
        $(e.currentTarget).addClass('active');

        e.preventDefault();

        $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'get_tax_by_news_filter_ajax',
                filter_val: $(this).attr('data-filter'),
            },
            beforeSend: function(data) {

            },
            success: function(data) {
                $('.news_slider .splide__list').html(data);
                var newsslideWidth = isMobile ? 300 : 400;
                var newsslideGap = isMobile ? 16 : 40;
                var newsSlider = new Splide('.news_slider', {
                    fixedWidth: newsslideWidth,
                    gap: newsslideGap,
                    arrows: false,
                    pagination: false,
                    autoHeight: true,
                });
                newsSlider.mount();
                var _newsComponents = newsSlider.Components,
                    newsController = _newsComponents.Controller,
                    newsMove = _newsComponents.Move;
                var newsprevButton = document.querySelector(
                    '.news_slider_wrapper .prev_button');
                newsprevButton.style.display = 'none';
                newsprevButton.addEventListener('click', function() {
                    var newsmaxPosition = Math.min(newsMove.getPosition() +
                        newsslideWidth +
                        newsslideGap, 0);
                    newsController.scroll(newsmaxPosition);
                });
                var newsnextButton = document.querySelector(
                    '.news_slider_wrapper .next_button');
                newsnextButton.addEventListener('click', function() {
                    var newsminPosition = Math.max(newsMove.getPosition() -
                        newsslideWidth -
                        newsslideGap, newsMove.getLimit(true));
                    newsController.scroll(newsminPosition);
                });
                newsSlider.on('moved', hideNewsArrows);
                newsSlider.on('scrolled', hideNewsArrows);

                function hideNewsArrows() {
                    var newsposition = newsMove.getPosition();
                    var newslimit = newsMove.getLimit(true);
                    if (newsposition >= 0) {
                        newsprevButton.style.display =
                            'none';
                    } else {
                        newsprevButton.style.display = 'inline-flex';
                    }
                    if (newsposition <=
                        newslimit) {
                        newsnextButton.style.display = 'none';
                    } else {
                        newsnextButton.style.display = 'inline-flex';
                    }
                }
            },
        });
    });

    $('#filter-events').on('click', 'button', function(e) {

        $('.cat').removeClass('active');
        $(e.currentTarget).addClass('active');

        e.preventDefault();

        $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'get_tax_by_events_filter_ajax',
                filter_val: $(this).attr('data-filter'),
            },
            beforeSend: function(data) {

            },
            success: function(data) {
                $('.events_slider .splide__list').html(data);
                var eventsslideWidth = isMobile ? 300 : 400;
                var eventsslideGap = isMobile ? 16 : 40;
                var eventsSlider = new Splide('.events_slider', {
                    fixedWidth: eventsslideWidth,
                    gap: eventsslideGap,
                    arrows: false,
                    pagination: false,
                    autoHeight: true,
                });
                eventsSlider.mount();
                var _eventsComponents = eventsSlider.Components,
                    eventsController = _eventsComponents.Controller,
                    eventsMove = _eventsComponents.Move;
                var eventsprevButton = document.querySelector(
                    '.events_slider_wrapper .prev_button');
                eventsprevButton.style.display = 'none';
                eventsprevButton.addEventListener('click', function() {
                    var eventsmaxPosition = Math.min(eventsMove.getPosition() +
                        eventsslideWidth +
                        eventsslideGap, 0);
                    eventsController.scroll(eventsmaxPosition);
                });
                var eventsnextButton = document.querySelector(
                    '.events_slider_wrapper .next_button');
                eventsnextButton.addEventListener('click', function() {
                    var eventsminPosition = Math.max(eventsMove.getPosition() -
                        eventsslideWidth -
                        eventsslideGap, eventsMove.getLimit(true));
                    eventsController.scroll(eventsminPosition);
                });
                eventsSlider.on('moved', hideEventsArrows);
                eventsSlider.on('scrolled', hideEventsArrows);

                function hideEventsArrows() {
                    var eventsposition = eventsMove.getPosition();
                    var eventslimit = eventsMove.getLimit(true);
                    if (eventsposition >= 0) {
                        eventsprevButton.style.display =
                            'none';
                    } else {
                        eventsprevButton.style.display = 'inline-flex';
                    }
                    if (eventsposition <=
                        eventslimit) {
                        eventsnextButton.style.display = 'none';
                    } else {
                        eventsnextButton.style.display = 'inline-flex';
                    }
                }
            },
        });
    });

    $('#filter-rooms').on('click', 'button', function(e) {
        $('.cat').removeClass('active');
        $(e.currentTarget).addClass('active');

        e.preventDefault();

        $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'get_rooms_by_filter_ajax',
                filter_val: $(this).attr('data-filter'),
            },
            beforeSend: function(data) {

            },
            success: function(data) {
                $('.rooms_slider .splide__list').html(data);
                var roomsslideWidth = isMobile ? 300 : 400;
                var roomsslideGap = isMobile ? 16 : 40;
                var roomsSlider = new Splide('.rooms_slider', {
                    fixedWidth: roomsslideWidth,
                    gap: roomsslideGap,
                    arrows: false,
                    pagination: false,
                    autoHeight: true,
                });
                roomsSlider.mount();
                var _roomsComponents = roomsSlider.Components,
                    roomsController = _roomsComponents.Controller,
                    roomsMove = _roomsComponents.Move;
                var roomsprevButton = document.querySelector(
                    '.rooms_slider_wrapper .prev_button');
                roomsprevButton.style.display = 'none';
                roomsprevButton.addEventListener('click', function() {
                    var roomsmaxPosition = Math.min(roomsMove.getPosition() +
                        roomsslideWidth +
                        roomsslideGap, 0);
                    roomsController.scroll(roomsmaxPosition);
                });
                var roomsnextButton = document.querySelector(
                    '.rooms_slider_wrapper .next_button');
                roomsnextButton.addEventListener('click', function() {
                    var roomsminPosition = Math.max(roomsMove.getPosition() -
                        roomsslideWidth -
                        roomsslideGap, roomsMove.getLimit(true));
                    roomsController.scroll(roomsminPosition);
                });
                roomsSlider.on('moved', hideRoomsArrows);
                roomsSlider.on('scrolled', hideRoomsArrows);

                function hideRoomsArrows() {
                    var roomsposition = roomsMove.getPosition();
                    var roomslimit = roomsMove.getLimit(true);
                    if (roomsposition >= 0) {
                        roomsprevButton.style.display =
                            'none';
                    } else {
                        roomsprevButton.style.display = 'inline-flex';
                    }
                    if (roomsposition <=
                        roomslimit) {
                        roomsnextButton.style.display = 'none';
                    } else {
                        roomsnextButton.style.display = 'inline-flex';
                    }
                }
            },
        });
    });

    // Offers slider component init
    if (document.querySelector('.offers_slider_wrapper')) {
        var slideWidth = isMobile ? 300 : 400;
        var slideGap = isMobile ? 16 : 40;
        var offersSlider = new Splide('.offers_slider', {
            fixedWidth: slideWidth,
            gap: slideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        offersSlider.mount();
        var _Components = offersSlider.Components,
            Controller = _Components.Controller, Move = _Components.Move;
        var prevButton = document.querySelector(
            '.offers_slider_wrapper .prev_button');
        prevButton.style.display = 'none';
        prevButton.addEventListener('click', function() {
            var maxPosition = Math.min(Move.getPosition() +
                slideWidth +
                slideGap, 0);
            Controller.scroll(maxPosition);
        });
        var nextButton = document.querySelector(
            '.offers_slider_wrapper .next_button');
        nextButton.addEventListener('click', function() {
            var minPosition = Math.max(Move.getPosition() -
                slideWidth -
                slideGap, Move.getLimit(true));
            Controller.scroll(minPosition);
        });
        offersSlider.on('moved', hideArrows);
        offersSlider.on('scrolled', hideArrows);

        function hideArrows() {
            var position = Move.getPosition();
            var limit = Move.getLimit(true);
            if (position >= 0) {
                prevButton.style.display = 'none';
            } else {
                prevButton.style.display = 'inline-flex';
            }
            if (position <= limit) {
                nextButton.style.display = 'none';
            } else {
                nextButton.style.display = 'inline-flex';
            }
        }
    }

    // events slider component init
    if (document.querySelector('.events_slider_wrapper')) {
        var eventsslideWidth = isMobile ? 300 : 400;
        var eventsslideGap = isMobile ? 16 : 40;
        var eventsSlider = new Splide('.events_slider', {
            fixedWidth: eventsslideWidth,
            gap: eventsslideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        eventsSlider.mount();
        var _eventsComponents = eventsSlider.Components,
            eventsController = _eventsComponents.Controller,
            eventsMove = _eventsComponents.Move;
        var eventsprevButton = document.querySelector(
            '.events_slider_wrapper .prev_button');
        eventsprevButton.style.display = 'none';
        eventsprevButton.addEventListener('click', function() {
            var eventsmaxPosition = Math.min(eventsMove.getPosition() +
                eventsslideWidth +
                eventsslideGap, 0);
            eventsController.scroll(eventsmaxPosition);
        });
        var eventsnextButton = document.querySelector(
            '.events_slider_wrapper .next_button');
        eventsnextButton.addEventListener('click', function() {
            var eventsminPosition = Math.max(eventsMove.getPosition() -
                eventsslideWidth -
                eventsslideGap, eventsMove.getLimit(true));
            eventsController.scroll(eventsminPosition);
        });
        eventsSlider.on('moved', hideeventsArrows);
        eventsSlider.on('scrolled', hideeventsArrows);

        function hideeventsArrows() {
            var eventsposition = eventsMove.getPosition();
            var eventsslimit = eventsMove.getLimit(true);
            if (eventsposition >= 0) {
                eventsprevButton.style.display = 'none';
            } else {
                eventsprevButton.style.display = 'inline-flex';
            }
            if (eventsposition <= eventsslimit) {
                eventsnextButton.style.display =
                    'none';
            } else {
                eventsnextButton.style.display = 'inline-flex';
            }
        }
    }

    // news slider component init
    if (document.querySelector('.news_slider_wrapper')) {
        var newsslideWidth = isMobile ? 300 : 400;
        var newsslideGap = isMobile ? 16 : 40;
        var newsSlider = new Splide('.news_slider', {
            fixedWidth: newsslideWidth,
            gap: newsslideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        newsSlider.mount();
        var _newsComponents = newsSlider.Components,
            newsController = _newsComponents.Controller,
            newsMove = _newsComponents.Move;
        var newsprevButton = document.querySelector(
            '.news_slider_wrapper .prev_button');
        newsprevButton.style.display = 'none';
        newsprevButton.addEventListener('click', function() {
            var newsmaxPosition = Math.min(newsMove.getPosition() +
                newsslideWidth +
                newsslideGap, 0);
            newsController.scroll(newsmaxPosition);
        });
        var newsnextButton = document.querySelector(
            '.news_slider_wrapper .next_button');
        newsnextButton.addEventListener('click', function() {
            var newsminPosition = Math.max(newsMove.getPosition() -
                newsslideWidth -
                newsslideGap, newsMove.getLimit(true));
            newsController.scroll(newsminPosition);
        });
        newsSlider.on('moved', hideNewsArrows);
        newsSlider.on('scrolled', hideNewsArrows);

        function hideNewsArrows() {
            var newsposition = newsMove.getPosition();
            var newslimit = newsMove.getLimit(true);
            if (newsposition >= 0) {
                newsprevButton.style.display = 'none';
            } else {
                newsprevButton.style.display = 'inline-flex';
            }
            if (newsposition <= newslimit) {
                newsnextButton.style.display =
                    'none';
            } else {
                newsnextButton.style.display = 'inline-flex';
            }
        }
    }

    // Rooms slider component init
    if (document.querySelector('.rooms_slider_wrapper')) {
        var roomsslideWidth = isMobile ? 300 : 400;
        var roomsslideGap = isMobile ? 16 : 40;
        var roomsSlider = new Splide('.rooms_slider', {
            fixedWidth: roomsslideWidth,
            gap: roomsslideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        roomsSlider.mount();
        var _roomsComponents = roomsSlider.Components,
            roomsController = _roomsComponents.Controller,
            roomsMove = _roomsComponents.Move;
        var roomsprevButton = document.querySelector(
            '.rooms_slider_wrapper .prev_button');
        roomsprevButton.style.display = 'none';
        roomsprevButton.addEventListener('click', function() {
            var roomsmaxPosition = Math.min(roomsMove.getPosition() +
                roomsslideWidth +
                roomsslideGap, 0);
            roomsController.scroll(roomsmaxPosition);
        });
        var roomsnextButton = document.querySelector(
            '.rooms_slider_wrapper .next_button');
        roomsnextButton.addEventListener('click', function() {
            var roomsminPosition = Math.max(roomsMove.getPosition() -
                roomsslideWidth -
                roomsslideGap, roomsMove.getLimit(true));
            roomsController.scroll(roomsminPosition);
        });
        roomsSlider.on('moved', hideRoomsArrows);
        roomsSlider.on('scrolled', hideRoomsArrows);

        function hideRoomsArrows() {
            var roomsposition = roomsMove.getPosition();
            var roomslimit = roomsMove.getLimit(true);
            if (roomsposition >= 0) {
                roomsprevButton.style.display = 'none';
            } else {
                roomsprevButton.style.display = 'inline-flex';
            }
            if (roomsposition <= roomslimit) {
                roomsnextButton.style.display =
                    'none';
            } else {
                roomsnextButton.style.display = 'inline-flex';
            }
        }
    }

}(jQuery));


